<template>
  <div>
    <table>
      <tr v-for="(item, index) in value.items" :key="index">
        <td class="pr-2 text-nowrap">{{ item.quantity }} x</td>
        <td>
          {{ item.productName }} ({{ value.supplier.name }})
          <small class="text-muted ml-1" v-if="value.createdByContact">
            by
            <span class="text-body">
              {{ contactName }}
            </span>
            ({{ value.createdByContact.account.role }})
          </small>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import { CondOperator, RequestQueryBuilder } from '@dataui/crud-request';
import axios from 'axios';

export async function fetchProductOrders({ job: { sfid: jobSfid } }) {
  const queryString = RequestQueryBuilder.create({
    filter: {
      field: `job.id`,
      operator: CondOperator.EQUALS,
      value: jobSfid,
    },
  }).query();

  return await axios
    .get(`/documents-api/product-orders/?${queryString}`)
    .then(({ data }) =>
      data.map((value) => ({
        time: new Date(value.createdAt),
        value,
      })),
    );
}

export default {
  props: {
    value: Object,
  },

  computed: {
    contactName() {
      const { createdByContact } = this.value;

      return createdByContact?.firstName && createdByContact?.lastName
        ? `${createdByContact.firstName} ${createdByContact.lastName}`
        : createdByContact?.email;
    },
  },
};
</script>
